import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f607af1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7f607af1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f607af1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f607af1')) {
      api.createRecord('7f607af1', component.options)
    } else {
      api.reload('7f607af1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f607af1&scoped=true", function () {
      api.rerender('7f607af1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stake/boosting/index.vue"
export default component.exports